import React from "react";
import "../../css/featured.css";
import ExploreMore from "../../ExploreMore";
import Navbar from "../../Navbar";
export const Toyota = () => {
  return (
    <>
      <Navbar />
      <div className="featured-con">
        <div className="layout">
          <h1 className="article-title">
            Toyota Subsidiary Agrees to $1.6 Billion Settlement in Emissions
            Scandal.
          </h1>
          {/* <div className="article-category">
            Canada's 10 Most Influential Women Leaders to Watch in 2024
          </div> */}
          <div className="share-container">
            <div className="share-buttons">
              <button className="share-button linkedin">LinkedIn</button>
              <button className="share-button twitter">Twitter</button>
              <button className="share-button facebook">Facebook</button>
            </div>
          </div>
          <div className="article-image-container">
            <img
              src="./images/navnews/toyota.png"
              alt="Professional woman at desk"
              className="article-image"
            />
            {/* <div className="article-image-caption">
            
            </div> */}
          </div>
          {/* Article Content */}
          <div className="article-content">
            <p>
              Toyota subsidiary Hino Motors has agreed to a $1.6 billion (£1.3
              billion) settlement and will plead guilty to deceiving US
              regulators about emissions levels from its diesel engines. The
              company will also face a five-year ban on exporting its diesel
              engines to the United States. Hino was charged with fraud in a
              Detroit court for selling 105,000 non-compliant engines in the US
              between 2010 and 2022. The US Justice Department stated that Hino
              submitted “false and fraudulent” emissions and fuel consumption
              data in a “criminal conspiracy” to gain a competitive advantage.
              “Hino Motors engaged in a years-long scheme to alter and fabricate
              emissions data to boost its bottom line,” said FBI Director
              Christopher Wray. He added that the scheme violated laws designed
              to protect public health and the environment. As part of the
              settlement, Hino will implement a compliance and ethics plan
              during the five-year export ban. Additionally, the company has
              committed to recalling some non-compliant heavy-duty trucks and
              replacing marine and locomotive engines across the US to mitigate
              environmental harm. Hino’s CEO, Satoshi Ogiso, issued an apology,
              stating, “We deeply regret the inconvenience caused to our
              customers and stakeholders” and pledged to strengthen compliance
              measures. The company reported an extraordinary loss of 230
              billion yen (£1.2 billion, $1.48 billion) in its October financial
              results to cover legal expenses. The case follows the infamous
              “dieselgate” scandal, where Volkswagen and its subsidiaries
              admitted to emissions fraud, costing the group over €30 billion
              (£25 billion, $30.9 billion) in fines, recalls, and compensation.
            </p>
          </div>
        </div>
      </div>
      <ExploreMore />
    </>
  );
};
